module.exports = __webpack_public_path__ + "static/img/17.bf316a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/17.jpg
// module id = NMl3
// module chunks = 0